
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { KanbanState } from '../kanban.model';

@Component({
  name: 'AdvancedUiSetting',
  components: {},
})
export default class AdvancedUiSetting extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  get advancedUi(): boolean {
    return this.state.settings!.advancedUi;
  }

  set advancedUi(val: boolean) {
    this.state.settings!.advancedUi = val;
    this.onAdvancedUiChanged();
  }

  get uid(): string {
    return (this as any)._uid;
  }

  private async saveSettings(): Promise<void> {
    await this.state.settingsAPI.update('KanbanSettings', false, false, JSON.stringify(this.state.settings));
  }

  private async onAdvancedUiChanged(): Promise<void> {
    await this.saveSettings();

    //TODO this is an ugly hack to trigger a refresh of the ui due to the layout variable change that should be triggered automatically by vue but isn't
    let x = this.state.settings;
    this.state.settings = null;
    this.state.settings = x;
  }
}
